module.exports = __webpack_public_path__ + "img/6.eca0dcc0.jpg";